export default function sugestoesDoHistorico(texto, limite = 300) {
  const historico = (texto || '').replace(/\s+/g, ' ').trim();

  if (!historico) return [];

  const tokens = historico.split(' ');
  const ehNumero = t => /^\d+$/.test(t);
  const lista = [];

  let inicio = 0;
  while (inicio < tokens.length && !ehNumero(tokens[inicio])) inicio++;

  for (let i = inicio; i < tokens.length; i++) {
    if (!ehNumero(tokens[i])) break;
    lista.push(tokens.slice(i).join(' '));
  }

  let depois = inicio;
  while (depois < tokens.length && ehNumero(tokens[depois])) depois++;
  if (depois < tokens.length) lista.push(tokens.slice(depois).join(' '));

  lista.push(historico);

  const vistos = {};
  return lista
    .map(t => (t || '').trim().slice(0, limite))
    .filter(t => {
      if (t.length < 3 || vistos[t]) return false;
      vistos[t] = true;
      return true;
    })
    .slice(0, 6);
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/sugestoes-historico.js